import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ModalController, Events, LoadingController } from 'ionic-angular';
import { HttpProvider } from '../../providers/http/http';
import { Stripe } from '@ionic-native/stripe';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { DomSanitizer } from '@angular/platform-browser';
import { FileTransfer, FileTransferObject, FileUploadOptions } from '@ionic-native/file-transfer';
import { HomePage } from '../home/home';
/**
 * Generated class for the OrdenPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

// @IonicPage()
@Component({
  selector: 'page-orden',
  templateUrl: 'orden.html',
})
export class OrdenPage {
  carrito: any = []
  path:any = this.http.images
  total: any = 0
  metodo: any = 0
  met: any = ''
  orden: any = {}
  form : any ={
    nombre:'',
    apellido:'',
    identificacion:'',
    tipo:'',
    banco:'',
    correo:'',
    referencia:'',
    fecha:'',
  }
  tarjeta : any = {
    numero:'',
    vencimiento:'',
    cvc:'',
  }
  id: any = window.localStorage.getItem('id')
  secret_key : any = 'pk_test_ctcrmivUzyMZdP1vs2SgsA54'
  show: any = false
  img_prev: any = null
  img: any = {}
  resp:any = false
  mssg_1:any = ''
  loadModal:any
  mssg_2:any = ''
  constructor(
    public navCtrl : NavController, 
    public navParams : NavParams,
    public http : HttpProvider,
    public loadingCtrl: LoadingController,
    public alrtCrtl : AlertController,
    public modal : ModalController,
    public stripe : Stripe,
    public camera : Camera,
    public sanitizer: DomSanitizer,
    public transfer : FileTransfer,
    public events : Events
    ) {
    if(window.localStorage.getItem('carrito')){
      this.carrito = JSON.parse(window.localStorage.getItem('carrito'))
      this.id
      this.metodo = this.navParams.get('metodo')
      this.met = this.navParams.get('met')
      this.carrito.map(el=>{
        this.total+=el.precio*el.cant
      })
    }
  }

  ActivarLoading() {
    this.loadModal = this.loadingCtrl.create({
      content: 'Por favor espere...'
    });
    this.loadModal.present();
  }
  DesactivarLoading() {
    this.loadModal.dismiss();
  }

  ionViewDidLoad() {
    this.stripe.setPublishableKey('pk_test_ctcrmivUzyMZdP1vs2SgsA54')
  }

  validar():boolean{
    if(this.metodo !== 'Zelle'){
      if(this.form.nombre.length <1 || this.form.apellido.length < 1
        || this.form.identificacion.length <1 || this.form.tipo.length < 1
        || this.form.banco.length <1 ||this.form.referencia.length < 1
        || this.form.fecha.length < 1 || !this.img_prev
      ){
        return false
      }else{
        return true
      }
    }else{
      if(this.form.nombre.length <1 || this.form.apellido.length <1
        || this.form.correo.length <1||this.form.referencia.length <1
        || this.form.fecha.length <1 || !this.img_prev
      ){
        return false
      }else{
        return true
      }
    }  
  }

  pagarStripe(){
    if(this.metodo === 'TDC'){
      this.ActivarLoading()
      this.show = true
      this.stripe.createCardToken({
        number: this.tarjeta.numero,
        expMonth: this.tarjeta.vencimiento.substring(5),
        expYear: this.tarjeta.vencimiento.substring(0,4),
        cvc: this.tarjeta.cvc
      })
      .then(
        res=>{
          this.orden.token = res.id
          this.total = this.total.toString()+'00'
          this.pagar()
        },
        error=>{
          console.log(error)
          this.DesactivarLoading()
          this.alertError(error)
        }
      )
      .catch(error=>{
        console.log(error)
        this.DesactivarLoading()
        this.alertError(error)
      })
    }
  }

  alertError(text){
    console.log(text)
    this.alrtCrtl.create({
      title: 'Atención',
      subTitle: text.error,
      buttons:['Aceptar']
    }).present()
  }

  pagar(){
    if(this.validar()){
      if(!this.show){
        this.ActivarLoading()
      }
      this.orden = {
        ...this.orden,
        products : this.carrito,
        total: this.total,
        client: this.id,
        payment : this.metodo,
        pago : this.form
      }
      if(this.img_prev){
        const fileTransfer : FileTransferObject = this.transfer.create()
        let options: FileUploadOptions ={
          httpMethod: 'POST',
          params: this.orden,
          fileKey: 'file',
          headers: {},
        }
        fileTransfer.upload(this.img,this.http.path+'orden',options)
          .then(
            (res:any)=>{
              this.DesactivarLoading()
              if(res.error || res.state === 'denied'){
                this.resp = true
                this.mssg_1 = 'Tu pago fue rechazado'
                this.mssg_2 = res.error
              }else{
                this.resp = true
                this.mssg_1 = 'Tu pago está en revisión'
                this.mssg_2 = 'En 48 horas será aprobado'
                window.localStorage.setItem('carrito',JSON.stringify(this.carrito = []))
                this.events.publish('carrito:update')
                // this.alrtCrtl.create({
                //   title: 'Atención',
                //   subTitle: 'Orden creada exitosamente',
                //   buttons:[
                //     {
                //       text: 'Aceptar',
                //       cssClass:'btn',
                //       handler:()=>{
                //         this.navCtrl.setRoot(OrdenesPage)
                //       }
                //     }
                //   ]
                // }).present()
              }
            },
            (error:any)=>{
              this.DesactivarLoading()
              console.log(error)
            }
          )
          .catch(error=>{
            this.DesactivarLoading()
            console.log(error)
          })
      }else{
        this.http.post('orden',this.orden).subscribe(
          (res:any)=>{
            this.DesactivarLoading()
            if(res.error || res.state === 'denied'){
              this.resp = true
              this.mssg_1 = 'Tu pago fue rechazado'
              this.mssg_2 = res.error
            }else{
              this.resp = true
              this.mssg_1 = 'Tu pago fue aprobado'
              this.mssg_2 = 'Retira nuestros productos en tu tienda física'
              window.localStorage.setItem('carrito',JSON.stringify(this.carrito = []))
              this.events.publish('carrito:update')
              // this.alrtCrtl.create({
              //   title: 'Atención',
              //   subTitle: 'Orden creada exitosamente',
              //   buttons:[
              //     {
              //       text: 'Aceptar',
              //       cssClass:'btn',
              //       handler:()=>{
              //         this.navCtrl.setRoot(OrdenesPage)
              //       }
              //     }
              //   ]
              // }).present()
            }
          },
          error=>{
            console.log(error)
            this.DesactivarLoading()
            this.alertError(error)
          }
        )
      }
    }else{
    this.alrtCrtl.create({
      title: 'Atención',
      subTitle: 'Verifique que haya completado todos los campos',
      buttons:[
        {
          text: 'Aceptar',
          cssClass:'btn',
          handler:()=>{}
        }
      ]
    }).present()
    }
  }

  quitarImg(){
    this.img_prev = null
  }

  selecImg(){
    let optionsImg: CameraOptions = {
      quality:100,
      destinationType: this.camera.DestinationType.FILE_URI,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      sourceType: this.camera.PictureSourceType.SAVEDPHOTOALBUM,
      targetHeight: 400,
      targetWidth: 400,
      allowEdit: false
    }
    this.camera.getPicture(optionsImg).then(
      res=>{ 
        this.img = res 
        this.img_prev = (<any>window).Ionic.WebView.convertFileSrc(res)
      },
      error=>console.log(error)
    )
  }

  home(){
    this.navCtrl.setRoot(HomePage)
  }

}



// WEBPACK FOOTER //
// ./src/pages/orden/orden.ts